import React from "react"
import { StyledInput } from "./style"

const Input = (props: any) => {
  return <StyledInput {...props} />
}

export default Input
